import { useDispatch, useSelector } from 'react-redux';
import ModalBody from '../../../../modals/modalBody';
import EditorTitle from '../../commonElements/editorTitle';
import { useTranslate } from '@tolgee/react';
import { getDateTimeFormated } from '../../../../utils/dates/utils';
import CreatorTitle from '../../commonElements/creatorTitle';
import {
  setShowPostIdeaModal,
  updatePostText
} from '../../../../../redux/slices/lomavisCreator/lomavisCreator';
import { useEffect, useRef, useState } from 'react';
import { MEDIA_TYPE_PDF, MEDIA_TYPE_VIDEO } from '../../../config/constants';
import ImageThumbnailLoader from '../../loaders/imageThumbnailLoader';
import { ALL, GENERIC } from '../../../../../config/constants';
import { handleMediaLibraryFileChange } from '../../MediaUploadArea/utils';
import toast from 'react-hot-toast';
import {
  countAllCharacters,
  getTextFromQuill,
  getUrlFromText,
  getUrlPreview,
  highlightFunctionAndQuillCopy
} from '../../creatorTextEditor/config';
import { relocatePublishButtons } from '../../../utils/uploadMediaFile';
import './styles.css';
import MediaModal from './mediaModal';
import ImageWithPlaceholder from '../../../../imageWithPlaceholder';
export const PostIdeaModal = ({ handleClose }) => {
  const dispatch = useDispatch();
  const { t } = useTranslate();
  const {
    postIdea,
    ui: { showPostIdeaModal }
  } = useSelector((state: any) => state.lomavisCreator);
  if (!postIdea || !showPostIdeaModal) {
    return null;
  }

  return (
    <ModalBody onClose={() => dispatch(setShowPostIdeaModal(false))}>
      <div
        className="post-idea-modal d-flex flex-column"
        style={{ height: '100%' }}
      >
        <div
          className="d-flex flex-column gap-3 flex-grow-1 p-3"
          style={{ overflowY: 'auto' }}
        >
          <div className="pi-card pi-header w-100 px-4 py-3 d-flex flex-row align-items-center justify-content-between">
            <EditorTitle title="postIdea" toolTip={false} />
            <span className="d-flex align-items-center text-muted small fw-semibold">
              <i className="fa-regular fa-clock me-2"></i>
              {getDateTimeFormated(postIdea?.created)}
            </span>
          </div>
          <div className="pi-card w-100 px-4 py-3">
            <AuthorInfoTable postIdea={postIdea} />
          </div>
          <div className="pi-card w-100 px-4 py-3">
            <PostIdeaMedia postIdea={postIdea} />
          </div>
          <div className="pi-card w-100 px-4 py-3 flex-grow-1">
            <PostText postIdea={postIdea} />
          </div>
        </div>
        <div className="pi-card mx-3 mb-3 px-4 py-3">
          <PostIdeaButtonsBar />
        </div>
      </div>
    </ModalBody>
  );
};

export const AuthorInfoTable = ({ postIdea }) => {
  const { t } = useTranslate(); // Using the `t` function for translations.

  const Field = ({
    label,
    value,
    html
  }: {
    label: string;
    value?: string | null;
    html?: string | null;
  }) => {
    const hasContent = html ? !!html : !!value;
    return (
      <div>
        <span className="pi-label">{label}</span>
        {hasContent ? (
          html ? (
            <div
              className="pi-value"
              dangerouslySetInnerHTML={{ __html: html }}
            />
          ) : (
            <div className="pi-value">{value}</div>
          )
        ) : (
          <div className="pi-value pi-value-empty">—</div>
        )}
      </div>
    );
  };

  return (
    <div className="w-100">
      <div className="mb-3">
        <CreatorTitle title={'authorInformations'} />
      </div>
      <div className="pi-info-grid">
        <Field
          label={t('lomavisCreator.postIdea.name')}
          value={postIdea?.author_name}
        />
        <Field
          label={t('lomavisCreator.postIdea.email')}
          value={postIdea?.author_email}
        />
        <Field
          label={t('lomavisCreator.postIdea.author_message')}
          value={postIdea?.author_message}
        />
        <Field
          label={t('lomavisCreator.postIdea.author_license_info')}
          value={postIdea?.author_license_info}
        />
        <Field
          label={t('lomavisCreator.postIdea.post_additional_information')}
          html={postIdea?.post_additional_information_html}
        />
        <Field
          label={t('lomavisCreator.postIdea.post_planned_publication_date')}
          value={postIdea?.post_planned_publication_date}
        />
      </div>
    </div>
  );
};

export const PostText = ({ postIdea }) => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const { useSeparateTextFields, quillEditors } = useSelector(
    (state: any) => state.lomavisCreator
  );

  return (
    <div className="w-100">
      <div className="d-flex justify-content-between align-items-center mb-3">
        <CreatorTitle title={'postText'} />
        <button
          className="btn btn-primary btn-sm d-inline-flex align-items-center"
          onClick={() => {
            const quillEditor = quillEditors?.[ALL];

            if (!quillEditor) return;
            quillEditor.setContents(postIdea.post_text);
            // setCursorPositionForQuill(quillInstance)
            const allQuillsButCurrent = Object.values(quillEditors);

            highlightFunctionAndQuillCopy(quillEditor, allQuillsButCurrent);
            // update text on the slice of the text
            const text = quillEditor.getText();
            const textWithMentions = getTextFromQuill(quillEditor);
            Promise.resolve(getUrlPreview(text)).then((urlPrev) => {
              dispatch(
                updatePostText({
                  text: quillEditor.getContents(),
                  text_as_html: quillEditor.root.innerHTML,
                  textText: textWithMentions,
                  platform: ALL,
                  urlPreview: urlPrev,
                  url_for_linkpreview: getUrlFromText(text),
                  fullCharacterCount: countAllCharacters(quillEditor)
                })
              );
            });
          }}
        >
          <i className="fa-regular fa-arrow-down-to-line me-2"></i>
          {t('lomavisCreator.postIdea.addPostText')}
        </button>
      </div>
      <div
        className="pi-value"
        dangerouslySetInnerHTML={{ __html: postIdea?.post_text_html }}
      ></div>
    </div>
  );
};

export const PostIdeaButtonsBar = () => {
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const footerRef = useRef(null);
  const [rightMargin, setRightMargin] = useState(0);
  const handleClose = () => {
    dispatch(setShowPostIdeaModal(false));
  };

  useEffect(() => {
    relocatePublishButtons({
      footerRef,
      setRightMargin
    });
  }, []);

  return (
    <div className="d-flex justify-content-end" ref={footerRef}>
      <button
        className="btn btn-secondary btn-sm"
        style={{ marginRight: rightMargin }}
        onClick={() => {
          handleClose();
        }}
      >
        {t('close')}
      </button>
    </div>
  );
};

export const PostIdeaMedia = ({ postIdea }) => {
  const {
    platformEnabled,
    postTypeSelected,
    useSeparateMediaFiles,

    postTypeSelected: { platform: typeKey },
    postData: {
      [ALL]: { media: postDataMediaFiles }
    }
  } = useSelector((state: any) => state.lomavisCreator);
  const [modalOpen, setModalOpen] = useState(false);
  const [modalMedia, setModalMedia] = useState(null);
  const handleMediaClick = (media) => {
    console.log('handleMediaClick', media);
    if (media.file_type === MEDIA_TYPE_PDF) {
      // Open PDF in a new tab
      window.open(media.original_asset, '_blank');
    } else {
      // Open image or video in modal
      setModalMedia(media);
      setModalOpen(true);
    }
  };
  const { t } = useTranslate();
  const dispatch = useDispatch();
  const [selectedMedia, setSelectedMedia] = useState([]);
  const onMediaClick = (image) => {
    // add media uuid to selectedMedia array
    if (selectedMedia.includes(image.uuid)) {
      setSelectedMedia(selectedMedia.filter((uuid) => uuid !== image.uuid));
    } else {
      setSelectedMedia([...selectedMedia, image.uuid]);
    }
  };

  return (
    <div className="w-100">
      <div className="d-flex justify-content-between align-items-center mb-3 flex-wrap gap-2">
        <CreatorTitle title={'media'} />
        <div className="d-flex gap-2">
          <button
            className="btn btn-light btn-sm d-inline-flex align-items-center"
            onClick={() => {
              if (useSeparateMediaFiles) {
                // show toastr
                toast.error(t('lomavisCreator.postIdea.mediaFilesSeparate'), {
                  position: 'top-right'
                });
                return;
              }
              const newMedia = postIdea.images.filter(
                (image) =>
                  !postDataMediaFiles
                    .map((file) => file.uuid)
                    .includes(image.uuid)
              );
              if (newMedia.length === 0 && selectedMedia.length > 0) {
                toast.error(
                  t('lomavisCreator.postIdea.cannotSelectAlreadySelectedMedia'),
                  {
                    position: 'top-right'
                  }
                );
                return;
              }

              setSelectedMedia(postIdea.images.map((image) => image.uuid));
              handleMediaLibraryFileChange(
                newMedia,
                dispatch,
                t,
                postDataMediaFiles,
                ALL,
                typeKey,
                postTypeSelected,
                platformEnabled
              );
            }}
          >
            <i className="fa-regular fa-layer-plus me-2"></i>
            {t('lomavisCreator.postIdea.addAllMedia')}
          </button>
          <button
            className="btn btn-primary btn-sm d-inline-flex align-items-center"
            onClick={() => {
              if (useSeparateMediaFiles) {
                // show toastr
                toast.error(t('lomavisCreator.postIdea.mediaFilesSeparate'), {
                  position: 'top-right'
                });
                return;
              }
              // filter already selected media
              const newMedia = postIdea.images
                .filter(
                  (image) =>
                    !postDataMediaFiles
                      .map((file) => file.uuid)
                      .includes(image.uuid)
                )
                .filter((image) => selectedMedia.includes(image.uuid));
              if (newMedia.length === 0 && selectedMedia.length > 0) {
                toast.error(
                  t('lomavisCreator.postIdea.cannotSelectAlreadySelectedMedia'),
                  {
                    position: 'top-right'
                  }
                );
                return;
              }
              handleMediaLibraryFileChange(
                newMedia,
                dispatch,
                t,
                postDataMediaFiles,
                ALL,
                typeKey,
                postTypeSelected,
                platformEnabled
              );
            }}
          >
            <i className="fa-regular fa-check me-2"></i>
            {t('lomavisCreator.postIdea.addSelectedMedia')}
          </button>
        </div>
      </div>
      {/* Loaders shown until images are loaded */}
      <MediaModal
        isOpen={modalOpen}
        media={modalMedia}
        onClose={() => {
          setModalOpen(false);
        }}
      />
      <div className="d-flex flex-wrap gap-3">
        {postIdea?.images?.map((image, index) => (
          <div
            key={index}
            onClick={() => {
              handleMediaClick(image);
            }}
            className={`card position-relative rounded shadow-sm cursor-pointer media-container ${
              selectedMedia.includes(image.uuid)
                ? 'border border-success border-2'
                : ''
            }`}
            style={{ width: '120px', height: '120px' }}
          >
            {/* Video Icon at Top Right for Video Media Type */}
            {image.media_type === MEDIA_TYPE_VIDEO && (
              <i
                className="fa-solid fa-play position-absolute text-white p-2"
                style={{
                  top: '8px',
                  right: '8px',
                  zIndex: 1
                }}
              ></i>
            )}
            {
              // ADD A DOWNLOAD icon for all media on buttom right
            }
            <div
              className="position-absolute bg-white rounded"
              style={{ bottom: '8px', right: '8px', zIndex: 1 }}
            >
              <i
                className="fa-solid fa-download text-dark p-2 "
                onClick={(e) => {
                  e.stopPropagation();
                  // Download the media
                  const link = document.createElement('a');
                  link.href = image.original_asset;
                  link.setAttribute('download', image.original_asset);
                  document.body.appendChild(link);
                  link.click();
                  document.body.removeChild(link);
                }}
              ></i>
            </div>
            {/* Checkbox at Top Right */}
            <input
              type="checkbox"
              checked={selectedMedia.includes(image.uuid)}
              onChange={() => {
                onMediaClick(image);
              }}
              onClick={(e) => {
                e.stopPropagation();
              }} // Prevent click event bubbling
              className="form-check-input position-absolute checkbox"
              style={{
                top: '8px',
                right: '8px',
                zIndex: 2
              }}
            />
            <ImageWithPlaceholder
              src={image.thumbnail_image}
              alt={`Media ${index}`}
              placeholder={
                <div className="m-1 overflow-hidden">
                  <ImageThumbnailLoader />
                </div>
              }
              className="img-thumbnail h-100 w-100"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
